import { formatDeadline, inProgressLateness } from '@/lib/diligenciaDisplay';
import PropTypes from 'prop-types';
import { isDeadlineExpired } from '@/lib/dateUtils';

// Presentación compartida por las tarjetas y la tabla de diligencias.
// La tabla usa DD/MM/YYYY; la tarjeta usa el día y el mes abreviado.
// Se conservan los tonos y el prefijo de atraso de la celda original.
export default function DeadlineCell({ t, compact = false, now = Date.now() }) {
  const dl = formatDeadline(t.deadline, now, t.deadlineExpiresAt);
  const past =
    isDeadlineExpired(t.deadline, t.deadlineExpiresAt, now) ??
    (dl.urgency === 'tight' && /^hace /.test(dl.delta || ''));
  const commitmentLate =
    inProgressLateness(
      t.stage,
      t.deadline,
      t.dateOffered,
      now,
      t.deadlineExpiresAt,
    ) === 'commitment-late';
  const cls =
    dl.urgency === 'tight'
      ? 'st--err'
      : commitmentLate || dl.urgency === 'medium'
        ? 'st--warn'
        : '';
  const base = compact ? dl.short : dl.numeric;
  const text = base === '—' ? dl.delta || '—' : base;
  return (
    <span
      className={cls || undefined}
      data-tip={
        past
          ? 'Plazo solicitado vencido'
          : commitmentLate
            ? 'Fecha comprometida por el receptor vencida · plazo vigente'
            : 'Plazo solicitado por el estudio'
      }
    >
      {past && !compact ? 'atrasada · ' : ''}
      {text}
    </span>
  );
}

DeadlineCell.propTypes = {
  t: PropTypes.shape({
    deadline: PropTypes.string,
    deadlineExpiresAt: PropTypes.string,
    stage: PropTypes.string,
    dateOffered: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
  now: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
};
